import type React from 'react';
import { useCallback } from 'react';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import { usePlaybooks } from '../use-playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const AlohaRuleCard: React.FC = () => {
  const openRuleEditor = useOpenRuleEditor();
  const { alohaRule } = usePlaybooks();
  const handleClick = useCallback(() => openRuleEditor(alohaRule), [openRuleEditor, alohaRule]);

  return (
    <PlaybookCard
      description={messages.alohaStateShippingDescription}
      glyph='locationPin'
      onClick={handleClick}
      title={messages.alohaStateShippingTitle}
    />
  );
};
